export interface Locale {
    code: string;
    title: string;
}

export function normaliseLocaleCode(localeCode: string): string {
    const [languageCode, variantCode] = (localeCode || '').split(/[_-]/);

    if (languageCode) {
        if (variantCode) {
            return `${languageCode.toLowerCase()}-${variantCode.toUpperCase()}`;
        }

        return languageCode.toLowerCase();
    }

    return '';
}

export function getLanguageCode(localeCode: string): string {
    const index = normaliseLocaleCode(localeCode).indexOf('-');
    return index > -1 ? localeCode.substr(0, index) : localeCode;
}
